//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  computed: {
    link_styles() {
      return 'text-gray-50 px-4 text-sm transition duration-500 ease-in-out whitespace-nowrap  hover:text-primary text-center relative cursor-pointer'
    },
    links(){
      let links = _.get(this.$store.state, 'globals.subheader_links', [])
      links = _.reject(links, link => {
        if(_.get(link, 'visibility') == 'authenticated' && !this.user) {
          return true
        }
        if(_.get(link, 'visibility') == 'guest' && this.user) {
          return true
        }
        return false
      })
      return links
    },
  },
  methods: {
    goTo(url) {
      return this.localePath(url)
    },
    action(item) {
      if(!_.get(item, 'url') && _.get(item, 'action')) {
        this.openCashier(_.get(item, 'action'))
      }
    }
  }
}
